"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeline = exports.getDetails = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    details: {
        client: 'v1/p/order/details',
    },
    timeline: {
        client: 'v1/p/order/timeline',
    },
};
const getDetails = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { hash }) {
    var _c;
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.details, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { hash }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return (_c = result.data) === null || _c === void 0 ? void 0 : _c.data;
});
exports.getDetails = getDetails;
const getTimeline = (_d, _e) => tslib_1.__awaiter(void 0, [_d, _e], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { hash }) {
    var _f;
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.timeline, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { hash }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return (_f = result.data) === null || _f === void 0 ? void 0 : _f.data;
});
exports.getTimeline = getTimeline;
//# sourceMappingURL=tracking.api.js.map